import type { ButtonProps } from '@/components/ui/button'
import { Button } from '@/components/ui/button'
import { classNames } from '@/utils/helpers'

type Props = React.PropsWithChildren<ButtonProps>

export const QuestionnaireFormButton = ({ className, ...props }: Props) => {
  return (
    <Button
      className={classNames(
        'h-max p-3 disabled:bg-secondary-200 disabled:text-white disabled:opacity-100',
        className,
      )}
      {...props}
    />
  )
}
